
import {defineComponent} from "vue";
import BasePopup from "@/components/Base/BasePopup.vue";
import { QrStream } from 'vue3-qr-reader';
import UserApi from "@/api/UserApi";
import {mapGetters} from "vuex";
import store from "@/store";
import BLoader from "@/components/BLoader/BLoader.vue";



export default defineComponent({
    components: {BLoader, BasePopup, QrStream },
    computed: {
        ...mapGetters(['balance'])
    },
    props: {
        prop_terminal_balance: {
            type: Number
        }
    },
    data() {
        return {
            state: {
                isLoading: false,
                terminal_step: 0
            },
            qr_code: '',
            terminal_balance: this.prop_terminal_balance as number,
            amount: 0
        }
    },
    methods: {
        onDecode(data: string) {
            if (data.includes('ECOcw')) {
                this.qr_code = data
            }
            if (data.includes('ecot')) {
                this.state.isLoading = true
                this.qr_code = data.replace('ecot_', '')

                UserApi
                    .startTerminal(this.qr_code)
                    .then((data) => {
                        this.amount = parseInt(data.data.amount)
                        this.state.terminal_step = 1
                    })
                    .catch(error => {
                        let status = error?.response?.status;
                        let message = `Неопознанная ошибка #${status}`;

                        switch (status) {
                            case 400:
                            case 401:
                                message = `Что-то пошло не так #${status}`;
                                break;
                            case 403:
                                message = error.response.data.message;
                                break;
                            case 404:
                                message = 'Терминал с указанным кодом не найден';
                                break
                            case 424:
                                message = 'Нет связи с терминалом';
                                break
                            case 423:
                                message = 'Оплата невозможна, сумма оплаты 0, терминал не ждёт оплаты';
                                break
                        }

                        alert(message);
                    })
                    .finally(() => {
                        this.state.isLoading = false
                    })
            }
        },
        close() {
            this.$emit('close');
        },
        washStart() {
            UserApi.startWash(this.qr_code, this.terminal_balance)
                .then(() => {
                    this.close()
                })
                .catch(error => {
                    if(error?.response?.data?.msg) {
                        alert(error.response.data.msg)
                    }
                })
                .finally(() => {
                    store.dispatch('getUserData')
                })
        },
        terminalPay() {
            this.state.isLoading = true
            UserApi
                .terminalPay(this.qr_code, this.amount)
                .then(() => {
                    this.close()
                })
                .catch(error => {
                    let status = error?.response?.status;
                    let message = `Неопознанная ошибка #${status}`;

                    switch (status) {
                        case 400:
                        case 401:
                            message = `Что-то пошло не так #${status}`;
                            break;
                        case 403:
                            message = error.response.data.message;
                            break;
                        case 404:
                            message = 'Терминал с указанным кодом не найден';
                            break
                        case 424:
                            message = 'Нет связи с терминалом';
                            break
                        case 423:
                            message = 'Оплата невозможна, терминал не ждёт оплаты, телефон или сумма на терминале не совпадают с указанными';
                            break
                    }
                    alert(message);
                })
                .finally(() => {
                    this.state.isLoading = false
                })
        }
    },
})
